import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  restoreActionInfo,
  saveActionDeviceStateInfo,
  saveActionDurationValueAfter,
  saveInitialActionInfo,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectColorActionHueAfterDuration
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/SelectColorActionScreens/SelectColorActionHueAfterDuration/SelectColorActionHueAfterDuration'
import SelectColorActionHueAfterDurationIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/SelectColorActionScreens/SelectColorActionHueAfterDuration/SelectColorActionHueAfterDuration'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectColorActionHueAfterDurationIOS) : withStyles(SelectColorActionHueAfterDuration)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    currentAction: {
      colorType,
      actionDeviceNumber,
      colorTypeDurationValueAfter,
    },
  } = state.scenes.currentSceneCreating
  return {
    actionDeviceNumber,
    colorType,
    isMobile,
    path,
    colorTypeDurationValueAfter,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  saveActionDurationValueAfter,
  saveActionDeviceStateInfo,
  saveInitialActionInfo,
  restoreActionInfo,
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectColorActionHueAfterDurationEnhanced = enhance

export default withRouter(SelectColorActionHueAfterDurationEnhanced)
